export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11115.3dbaefa9.jpg";